import * as React from 'react';
import { useCallback, useMemo } from 'react';

import { Route, Routes, useNavigate } from 'react-router-dom';

import StoreInfoModalContainer from 'components/store-info-modal';
import { relativeRoutes } from 'utils/routing';

interface IStoreInfoRoutes {
  setIsStoreInfoModalOpen?: (isOpen: boolean) => void;
}

export const StoreInfoRoutes: React.VFC<IStoreInfoRoutes> = ({ setIsStoreInfoModalOpen }) => {
  const navigate = useNavigate();

  const onDismiss = useCallback(() => {
    navigate('.');

    if (setIsStoreInfoModalOpen) {
      setIsStoreInfoModalOpen(false);
    }
  }, [navigate, setIsStoreInfoModalOpen]);

  const onOpen = useCallback(() => {
    if (setIsStoreInfoModalOpen) {
      setIsStoreInfoModalOpen(true);
    }
  }, [setIsStoreInfoModalOpen]);

  const storeInfoModal = useMemo(
    () => <StoreInfoModalContainer onDismiss={onDismiss} onOpen={onOpen} />,
    [onDismiss, onOpen]
  );

  return (
    <Routes>
      {/* Store info requests data by id and/or storeNumber supplied depending on route. */}
      <Route path={`${relativeRoutes.store}/:id`} element={storeInfoModal} />
      <Route path={`${relativeRoutes.store}/:storeNumber/*`} element={storeInfoModal} />
    </Routes>
  );
};
